import React from 'react';
import MyProfile from '../features/profiles/components/MyProfile';

const MyProfilePage = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Mi Perfil</h1>
        <p className="text-gray-600">Gestiona tu información personal y preferencias</p>
      </div>
      <MyProfile />
    </div>
  );
};

export default MyProfilePage;